import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  authAdminRoleGuard,
  authGuard,
  authMerchantRoleGuard,
} from './services/auth.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { freeOrganizerGuard } from './free-organizer/services/free-organizer.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'merchant',
    loadChildren: () =>
      import('./merchant/merchant.module').then((m) => m.MerchantModule),
    canActivate: [authGuard, authMerchantRoleGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [authGuard, authAdminRoleGuard],
  },
  {
    path: 'free-organizer',
    loadChildren: () =>
      import('./free-organizer/free-organizer.module').then(
        (m) => m.FreeOrganizerModule,
      ),
    // canActivate: [authGuard, freeOrganizerGuard],
  },
  {
    path: 'line-share',
    loadChildren: () =>
      import('./line-share/line-share.module').then((m) => m.LineShareModule),
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'legals',
    loadChildren: () =>
      import('./legals/legals.module').then((m) => m.LegalsModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      scrollOffset: [0, 0],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
